import { makeStyles } from "@cirrus/ui-kit"

import { cx } from "ramda-extension/es"

import React, { Component as C } from "react"
import PropTypes from "prop-types"

import withSkinV2 from "@cirrus/legacy/app-common/alt/framework/withSkinV2.jsx"
import { withUseStyles } from "@cirrus/legacy/app-common/utils/withUseStyles.jsx"

import SpreadContent from "./content.jsx"

import cv from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"

const useStyles = makeStyles({
  container: {
    display: "inline-block",
    position: "relative",
  },

  spread: {
    margin: 0,
    padding: 0,
    listStyle: "none",
    height: "4px",

    "& li": {
      display: "inline-block",
      marginRight: "2px",
      verticalAlign: "top",
      fontSize: "4px",
      "&:last-child": { marginRight: 0 },
    },
  },
})

class SpreadButtonContent extends C {
  constructor(props) {
    super(props)
  }

  static propTypes = {
    onClickButton: PropTypes.func,
    onClickOutside: PropTypes.func,
    isContentShown: PropTypes.bool,
    contentContainerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
  }

  onClickButton(e) {
    this.props.onClickButton()
  }

  render() {
    const {
      disabled,
      isContentShown,
      onClickOutside,
      contentClassName,
      contentContainerClassName,
      children,
      dynamicStyles,
      classes,
      buttonClass,
    } = this.props

    const spreadItems = Array.apply(null, new Array(3)).map((item, index) => {
      return <li key={index} className="icon icon-circle2" />
    })

    return (
      <div className={classes.container} ref="container">
        <button
          className={cx(dynamicStyles.classes.button, buttonClass)}
          onClick={this.onClickButton.bind(this)}
          disabled={disabled}>
          <ul className={classes.spread}>{spreadItems}</ul>
        </button>

        {isContentShown ? (
          <SpreadContent
            onClickOutside={onClickOutside}
            contentClassName={contentClassName}
            contentContainerClassName={contentContainerClassName}>
            {children}
          </SpreadContent>
        ) : null}
      </div>
    )
  }
}

const defaultSkinObject = {
  button: {
    height: "32px",
    lineHeight: "20px",
    cursor: "pointer",
    boxSizing: "border-box",
    borderRadius: "4px",
    padding: "10px",
    color: "",
    border: `2px solid ${cv.gray740}`,
    borderColor: "",
    backgroundColor: cv.white,
    height: "",

    pm_focus: {
      color: "",
      backgroundColor: "",
      borderColor: "",
    },

    pm_hover: {
      color: "",
      backgroundColor: "",
      borderColor: "",
    },

    pm_active: {
      color: "",
      backgroundColor: "",
      boxShadow: "",
      borderColor: "",
    },

    m_disabled: {
      color: "",
      borderColor: "",
    },
  },
}

export default withSkinV2({
  skinObjectSelector: (skinObject) => skinObject.shareButton || {},
  defaultSkinObject,
})(withUseStyles(SpreadButtonContent, useStyles))
